<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'SEGUROPLAN.LBL_CODPLAN' | translate }}</label>
          <input type="text" pInputText id="codigo"
                 name="nomCodigo"
                 autocomplete="off"
                 formControlName="codigo" codigos-reactive
                 [maxlength]="20"
                 (blur)="validarCodigo()"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
            {{ 'SEGUROPLAN.LBL_CODPLAN' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'SEGUROPLAN.LBL_NOMPLAN' | translate }}</label>
          <input type="text" pInputText id="nombre"
                 name="nomNombre"
                 autocomplete="off"
                 formControlName="nombre" capitalize-reactive
                 [maxlength]="100"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
            {{ 'SEGUROPLAN.LBL_NOMPLAN' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'SEGUROPLAN.LBL_VALORDEPLAN' | translate }}</label>
          <input type="text" pInputText id="valor"
                 name="nomValor"
                 autocomplete="off"
                 formControlName="valor"
                 [maxlength]="18"
                 currencyMask
                 [options]="{ prefix: '$ ', thousands: appSettingService.separadorMiles, decimal: appSettingService.separadorDecimales, align: 'left', allowNegative:false, precision : 0 }"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.valor.invalid">
            {{ 'SEGUROPLAN.LBL_VALORDEPLAN' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                    id="indicadorHabilitado"
                    name="nomIndicador"
                    formControlName="indicadorHabilitado"></p-checkbox>
      </div>
    </div>

    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>


  </form>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="lisSegurosPlan" selectionMode="single" dataKey="nombre"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.codigo}}</td>
            <td>{{row.nombre}}</td>
            <td>{{row.valor | dinero}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" (onChange)="cambiarHabilitado(row)"
                          [disabled]="segPlanSeleccionado && segPlanSeleccionado.idSeguroPlan === row.idSeguroPlan"></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                        [disabled]="segPlanSeleccionado && segPlanSeleccionado.idSeguroPlan === row.idSeguroPlan"
                        (click)="editar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<p-confirmDialog #cd key="plan">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
